export default [
  {
    description:
      'This year, In Collaboration with JakTent, we are presenting to you The Nextdev Summit. An amazing virtual event to connect & facilitate collaboration to accelerate Indonesia’s digital economy.',
    title: 'Sekilas Mengenai The Nextdev Summit 2020',
    media: ['https://i.imgur.com/L0DnjXv.mp4']
  }
]
